var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g2, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetaverse701(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22.43 16.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#001a41;}.cls-2{fill:url(#Degradado_sin_nombre_1113);}.cls-3{fill:url(#Degradado_sin_nombre_31);}.cls-4{fill:url(#Degradado_sin_nombre_7);}.cls-5{fill:url(#Degradado_sin_nombre_31-2);}.cls-6{fill:url(#Degradado_sin_nombre_12);}.cls-7{fill:url(#Degradado_sin_nombre_12-2);}.cls-8{fill:none;stroke:#2e516c;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px;}.cls-9{fill:#1e394b;}.cls-10{fill:url(#Degradado_sin_nombre_29);}.cls-11{fill:url(#Degradado_sin_nombre_14);}.cls-12{fill:url(#Degradado_sin_nombre_29-2);}.cls-13{fill:url(#Degradado_sin_nombre_1211);}.cls-14{fill:url(#Degradado_sin_nombre_1211-2);}.cls-15{opacity:0.59;}.cls-16{fill:#83d9ff;}.cls-17{fill:#0089cf;}.cls-18{isolation:isolate;}.cls-19{fill:url(#Degradado_sin_nombre_1211-3);}.cls-20{fill:url(#Degradado_sin_nombre_1211-4);}.cls-21{fill:url(#Degradado_sin_nombre_1199);}.cls-22{fill:url(#Degradado_sin_nombre_1199-2);}.cls-23{fill:url(#Degradado_sin_nombre_1113-2);}.cls-24{fill:url(#Degradado_sin_nombre_1113-3);}.cls-25{fill:url(#Degradado_sin_nombre_1113-4);}.cls-26{fill:url(#Degradado_sin_nombre_1113-5);}.cls-27{fill:url(#Degradado_sin_nombre_31-3);}.cls-28{fill:url(#Degradado_sin_nombre_31-4);}.cls-29{fill:url(#Degradado_sin_nombre_1211-5);}.cls-30{fill:url(#Degradado_sin_nombre_1199-3);}.cls-31{fill:url(#Degradado_sin_nombre_12-3);}.cls-32{fill:url(#Degradado_sin_nombre_12-4);}.cls-33{fill:url(#Degradado_sin_nombre_29-3);}.cls-34{fill:url(#Degradado_sin_nombre_14-2);}.cls-35{fill:url(#Degradado_sin_nombre_29-4);}.cls-36{fill:#87b3ca;}.cls-37{fill:#afd6ef;}.cls-38{fill:#ff99da;}.cls-39{fill:url(#Degradado_sin_nombre_1211-6);}.cls-40{fill:url(#Degradado_sin_nombre_1211-7);}.cls-41{fill:url(#Degradado_sin_nombre_1199-4);}.cls-42{fill:url(#Degradado_sin_nombre_1199-5);}.cls-43{fill:url(#Degradado_sin_nombre_1211-8);}.cls-44{fill:url(#Degradado_sin_nombre_1211-9);}.cls-45{fill:url(#Degradado_sin_nombre_1199-6);}.cls-46{fill:url(#Degradado_sin_nombre_1199-7);}.cls-47{fill:url(#Degradado_sin_nombre_1199-8);}.cls-48{fill:url(#Degradado_sin_nombre_1199-9);}.cls-49{fill:url(#Degradado_sin_nombre_1211-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1113",
    x1: -387.8,
    y1: 7.61,
    x2: -387.8,
    y2: 13.01,
    gradientTransform: "matrix(-1, 0, 0, 1, -381.22, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2760ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_31",
    x1: -1117.11,
    y1: 881.39,
    x2: -1117.11,
    y2: 880.66,
    gradientTransform: "matrix(1, 0.04, 0.04, -1, 1085.33, 939.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff817c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ff8d85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ffa89a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ffb9a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbfab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7",
    x1: 1746.08,
    y1: 12.74,
    x2: 1746.08,
    y2: 5.86,
    gradientTransform: "matrix(-1, 0, 0, 1, 1752.21, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80a4b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8edff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_31-2",
    x1: 68.51,
    y1: 5.89,
    x2: 68.51,
    y2: 4.99,
    gradientTransform: "matrix(-1, 0, 0, 1, 72, 0)",
    xlinkHref: "#Degradado_sin_nombre_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_12",
    x1: -387.95,
    y1: 4.9,
    x2: -387.95,
    y2: 5.45,
    gradientTransform: "matrix(1, 0, 0, -1, 394.68, 10.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff817c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbfab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_12-2",
    x1: -387.91,
    y1: 4.27,
    x2: -387.91,
    y2: 4.91,
    gradientTransform: "matrix(-1, 0, 0, 1, -381.22, 0)",
    xlinkHref: "#Degradado_sin_nombre_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_29",
    x1: 747.06,
    y1: 4.52,
    x2: 747.06,
    y2: 4.97,
    gradientTransform: "translate(-740.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e516c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#436987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6590b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#79a7ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81b0d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14",
    x1: 746.63,
    y1: 4.78,
    x2: 746.63,
    y2: 4.21,
    gradientTransform: "translate(-740.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e516c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81b0d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_29-2",
    x1: 746.29,
    y1: 4.09,
    x2: 746.85,
    y2: 4.44,
    xlinkHref: "#Degradado_sin_nombre_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211",
    x1: 1744.99,
    y1: 4.52,
    x2: 1745.91,
    y2: 8.18,
    gradientTransform: "matrix(-1, 0, 0, 1, 1752.21, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b0382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea3bec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-2",
    x1: 1745.52,
    y1: 5.36,
    x2: 1745.62,
    y2: 5.77,
    xlinkHref: "#Degradado_sin_nombre_1211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-3",
    x1: 1751.95,
    y1: 8.59,
    x2: 1748.41,
    y2: 10.69,
    xlinkHref: "#Degradado_sin_nombre_1211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-4",
    x1: 1751.94,
    y1: 8.58,
    x2: 1748.4,
    y2: 10.68,
    xlinkHref: "#Degradado_sin_nombre_1211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199",
    x1: 1752.06,
    y1: 0.08,
    x2: 1748.52,
    y2: 2.18,
    gradientTransform: "matrix(-1, 0, 0, 1, 1752.21, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec6a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbd23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199-2",
    x1: 1751.39,
    y1: 0.47,
    x2: 1748.87,
    y2: 1.96,
    xlinkHref: "#Degradado_sin_nombre_1199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1113-2",
    x1: 18.76,
    y1: 6.17,
    x2: 16.73,
    y2: 13.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1113-3",
    x1: 21.87,
    y1: 11.71,
    x2: 19.42,
    y2: 10.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1113-4",
    x1: -661.59,
    y1: 718.53,
    x2: -662.33,
    y2: 719.25,
    gradientTransform: "matrix(0.88, 0.47, -0.47, 0.88, 935.14, -308.67)",
    xlinkHref: "#Degradado_sin_nombre_1113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1113-5",
    x1: -419.75,
    y1: 382.55,
    x2: -420.5,
    y2: 383.27,
    gradientTransform: "translate(525.71 -235.07) rotate(16.19)",
    xlinkHref: "#Degradado_sin_nombre_1113"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_31-3",
    x1: -121.53,
    y1: 107.08,
    x2: -121.53,
    y2: 106.48,
    gradientTransform: "matrix(1, 0.09, -0.09, 1, 151.2, -91.06)",
    xlinkHref: "#Degradado_sin_nombre_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_31-4",
    x1: 2127.43,
    y1: 5.65,
    x2: 2127.43,
    y2: 5.05,
    gradientTransform: "matrix(-1, 0, 0, 1, 2143.36, -7.82)",
    xlinkHref: "#Degradado_sin_nombre_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-5",
    x1: -123.32,
    y1: 108.92,
    x2: -124.13,
    y2: 106.76,
    gradientTransform: "matrix(1, 0.09, -0.09, 1, 151.2, -91.06)",
    xlinkHref: "#Degradado_sin_nombre_1211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199-3",
    x1: -126.86,
    y1: 109.25,
    x2: -121.33,
    y2: 109.25,
    gradientTransform: "matrix(1, 0.09, -0.09, 1, 151.2, -91.06)",
    xlinkHref: "#Degradado_sin_nombre_1199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_12-3",
    x1: 1151.42,
    y1: 107.7,
    x2: 1151.42,
    y2: 108.26,
    gradientTransform: "matrix(-1, -0.09, -0.09, 1, 1174.46, -2.75)",
    xlinkHref: "#Degradado_sin_nombre_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_12-4",
    x1: 1151.44,
    y1: 107.06,
    x2: 1151.44,
    y2: 107.64,
    gradientTransform: "matrix(-1, -0.09, -0.09, 1, 1174.46, -2.75)",
    xlinkHref: "#Degradado_sin_nombre_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_29-3",
    x1: 48.15,
    y1: 107.7,
    x2: 48.15,
    y2: 108.15,
    gradientTransform: "matrix(1, 0.09, -0.09, 1, -20.89, -105.83)",
    xlinkHref: "#Degradado_sin_nombre_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14-2",
    x1: 47.72,
    y1: 107.97,
    x2: 47.72,
    y2: 107.4,
    gradientTransform: "matrix(1, 0.09, -0.09, 1, -20.89, -105.83)",
    xlinkHref: "#Degradado_sin_nombre_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_29-4",
    x1: 47.37,
    y1: 107.27,
    x2: 47.93,
    y2: 107.63,
    gradientTransform: "matrix(1, 0.09, -0.09, 1, -20.89, -105.83)",
    xlinkHref: "#Degradado_sin_nombre_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-6",
    x1: 14.58,
    y1: 5.37,
    x2: 14.58,
    y2: 4.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-7",
    x1: 9.72,
    y1: 5.82,
    x2: 9.88,
    y2: 5.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199-4",
    x1: 14.86,
    y1: 6.87,
    x2: 14.86,
    y2: 6.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199-5",
    x1: 10.56,
    y1: 1.93,
    x2: 10.56,
    y2: 1.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-8",
    x1: 11.84,
    y1: 9.06,
    x2: 11.84,
    y2: 8.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-9",
    x1: 12.55,
    y1: 1.78,
    x2: 12.55,
    y2: 0.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199-6",
    x1: 10.29,
    y1: 4.59,
    x2: 10.29,
    y2: 3.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199-7",
    x1: 13.44,
    y1: 9.32,
    x2: 13.44,
    y2: 8.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199-8",
    x1: 14.25,
    y1: 3.09,
    x2: 14.25,
    y2: 2.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1199-9",
    x1: 10.56,
    y1: 7.85,
    x2: 10.56,
    y2: 7.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1211-10",
    x1: 18.56,
    y1: 3.75,
    x2: 18.56,
    y2: 2.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Degradado_sin_nombre_1211"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.25,15s-.47.57-.6.76.09.29.26.25a8.34,8.34,0,0,0,.92-.48.16.16,0,0,0,.09-.14v-.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.32,14.6a7,7,0,0,0-.66.67c-.13.18.09.28.26.25s.73-.34,1-.45A.15.15,0,0,0,6,14.93v-.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.44,8.54S5.17,11,5.13,11.65c0,.44.18,3,.18,3,0,.38.67.17.67.17s.23-2.26.27-2.79l.39-2.07s.07,2.06.06,2.19.53,3,.53,3c0,.35.68.11.68.11l0-3S8,10.41,8,10,8,9,8,9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.49,9.07l.41,0h0a1.73,1.73,0,0,1,0,.49c0,.2-.16.29-.24.28s-.13,0-.19-.25a.6.6,0,0,1,0-.18s-.1.13-.16.1S8.36,9.2,8.49,9.07Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.05,8.93c0-.37-.11-1.18-.13-2l.32.64L8.46,9.1a.58.58,0,0,0,.45,0L9,7.53A1.09,1.09,0,0,0,9,7.06L8.4,5.92c-.21-.39-.45-.44-.83-.57L6.16,5.08a1.06,1.06,0,0,0-.61.06l-.88.42L3.54,5.05a.23.23,0,0,0-.3.1h0a.23.23,0,0,0,.08.31l1.19.83a.37.37,0,0,0,.27,0l.78-.12s-.14,1.53-.2,2.22a.19.19,0,0,0,.1.19,5.19,5.19,0,0,0,2.41.51A.18.18,0,0,0,8.05,8.93Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3.48,5.55,3.3,5.49a.21.21,0,0,1-.13-.16c0-.11,0-.26,0-.33s.08-.41.22-.4.24.19.28.4a.68.68,0,0,1,0,.21s.1-.15.16-.11,0,.22-.1.38A.18.18,0,0,1,3.48,5.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.07,4.13c0-.1-.32-.47-.22-.69s.49-.11.49-.11-.07-.1,0-.16,1.3.2,1.13,1c0,.28-.17.66-.82.55,0,0-.52-.39-.58-.57"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M6.57,4.41h.31a.21.21,0,0,1,.21.21v1a0,0,0,0,1,0,0H6.39a0,0,0,0,1,0,0v-1a.21.21,0,0,1,.21-.21Z",
    transform: "translate(13.46 10.04) rotate(-180)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M6.87,4.23a.16.16,0,0,1,.18.09h0a.06.06,0,0,0,.07,0,.05.05,0,0,0,0,0V4.16h0c.06,0,.15,0,.15.07a.35.35,0,0,1-.15.25v.15A.38.38,0,0,1,6.9,5l-.39.13a.37.37,0,0,1-.18,0,.32.32,0,0,1-.26-.32V4.13A.57.57,0,0,0,6.87,4.23Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M6.64,4.54a1.33,1.33,0,0,0,.83-.39"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M6.21,4.3s.06-.95.81-1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M6.72,4.45v.11a.11.11,0,0,1-.06.1l-.1.06L6,4.18l.1,0a.12.12,0,0,1,0,0,.92.92,0,0,0,.48.24h.12S6.72,4.43,6.72,4.45Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M6.52,4.51s0,0,0,0v.19a.08.08,0,0,1,0,.06l-.23.13s0,0,0,0V4.7a.08.08,0,0,1,0-.06Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M5.7,4.3a.07.07,0,0,0,0,.06v.19a0,0,0,0,0,0,0l.58.34s0,0,0,0V4.7a.08.08,0,0,1,0-.06L5.7,4.3Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6,4.16h0L5.7,4.3l.59.34h0l.23-.13h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6.69,5.68l.07,2.41a.24.24,0,0,1,0,.14l-.22.24a.19.19,0,0,1-.33-.05L6,8.09A.17.17,0,0,1,6,8l.49-2.33"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M6.81,5.54l-.32-.07s-.08,0-.07.08l.06.17a.13.13,0,0,0,.2.06l.16-.14A.06.06,0,0,0,6.81,5.54Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1.74,3.09c-.1-.06-.18,0-.18.1V7.24a.4.4,0,0,0,.18.31l5.33,3.08c.1,0,.18,0,.18-.1V6.47a.34.34,0,0,0-.17-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "2.31 4.13 2.31 4.99 2.41 5.05 2.41 4.19 2.31 4.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "2.02 4.91 2.02 4.94 3.23 5.63 3.23 5.6 2.02 4.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "3.13 4.58 3.13 5.46 3.23 5.52 3.23 4.64 3.13 4.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "2.59 4.03 2.58 5.15 2.69 5.21 2.69 4.09 2.59 4.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "2.04 4.26 2.04 4.83 2.14 4.89 2.14 4.32 2.04 4.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "2.86 4.85 2.85 5.31 2.96 5.37 2.96 4.91 2.86 4.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3.82,4.85s-.08,0-.08.05a.22.22,0,0,0,.08.15c.05,0,.09,0,.09,0A.17.17,0,0,0,3.82,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3.82,5.67s-.09,0-.09,0a.2.2,0,0,0,.09.15.06.06,0,0,0,.09,0A.19.19,0,0,0,3.82,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M4.14,5s-.08,0-.08,0a.18.18,0,0,0,.08.15c.05,0,.09,0,.09-.05A.2.2,0,0,0,4.14,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M4.14,5.44a.06.06,0,0,0-.09,0,.19.19,0,0,0,.09.15c.05,0,.09,0,.09,0A.2.2,0,0,0,4.14,5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M4.14,5.85s-.09,0-.09.05a.17.17,0,0,0,.09.15c.05,0,.09,0,.09,0A.2.2,0,0,0,4.14,5.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2.68,5.64c-.07,0-.13,0-.16,0l-.4.45,0,0,.4-.46a.12.12,0,0,1,.14,0,.34.34,0,0,1,.14.17l.23.55a.43.43,0,0,0,.16.19h0a.12.12,0,0,0,.15,0l.17-.14s.07,0,.12,0h0a.45.45,0,0,1,.13.17L4,7.1l0,.13.11.27a.4.4,0,0,0,.16.2.17.17,0,0,0,.13,0l0,0v0L5,7.19a.09.09,0,0,1,.13,0,.35.35,0,0,1,.15.17l.13.31a.47.47,0,0,0,.16.2.13.13,0,0,0,.17,0l.19-.23s.08,0,.14,0a.37.37,0,0,1,.14.16l.38.84h0l-.38-.85A.36.36,0,0,0,6,7.58a.12.12,0,0,0-.17,0l-.18.23a.1.1,0,0,1-.14,0,.32.32,0,0,1-.14-.16l-.14-.31a.41.41,0,0,0-.16-.2c-.07,0-.13,0-.16,0l-.44.48,0,0,0,0a.17.17,0,0,1-.12,0,.39.39,0,0,1-.14-.17l-.12-.3,0-.13-.18-.44a.39.39,0,0,0-.15-.2h0a.14.14,0,0,0-.16,0l-.16.14a.1.1,0,0,1-.13,0,.33.33,0,0,1-.14-.17l-.23-.55A.45.45,0,0,0,2.68,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M4.1,6.91,4,7.07l0,.13L4.17,7h0l0,0,.21.67,0,0,0,0L4.3,7a.23.23,0,0,0-.1-.13S4.12,6.88,4.1,6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3.82,5.26s-.08,0-.08,0a.17.17,0,0,0,.08.15.06.06,0,0,0,.09,0A.19.19,0,0,0,3.82,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M4.49,7.7l0,0,.19.59a.24.24,0,0,0,.09.13s.08,0,.1,0L5.15,8h0l0,0,.18.45a.23.23,0,0,0,.09.12s.08,0,.1,0l.31-.42h0s0,0,0,0L6.4,9.47h.07L6,8.21a.2.2,0,0,0-.1-.12.06.06,0,0,0-.09,0l-.31.43h0a0,0,0,0,1,0,0L5.27,8a.22.22,0,0,0-.1-.11s-.07,0-.09,0l-.32.43h0s0,0,0,0L4.5,7.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "4.72 5.99 4.72 6.06 6.05 6.83 6.05 6.75 4.72 5.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "4.72 5.8 4.72 5.87 6.05 6.64 6.05 6.57 4.72 5.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "6.75 7.66 6.74 9.94 2.13 7.27 2.13 7.32 6.78 10 6.79 7.69 6.75 7.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "4.73 5.61 4.73 5.68 6.05 6.45 6.05 6.38 4.73 5.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "4.73 5.42 4.73 5.5 6.05 6.26 6.05 6.19 4.73 5.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M6.26,6.31s0,0,0,0v.53a.09.09,0,0,0,0,.08l.46.27s0,0,0,0V6.66a.09.09,0,0,0,0-.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2.52,6.24l-.36.46.06.08.37-.45h0l0,0L3,7.31a.2.2,0,0,0,.09.11h0a.06.06,0,0,0,.09,0L3.54,7h0l0,0,.14.33a.25.25,0,0,0,.09.11h0s.08,0,.09,0l.13-.23L4,7.1l-.15.28s0,0,0,0l0,0L3.66,7a.24.24,0,0,0-.09-.11s-.07,0-.09,0l-.37.41h0l0,0-.35-.94a.23.23,0,0,0-.09-.12A.07.07,0,0,0,2.52,6.24Z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.12,8.42c-.13-.07-.22,0-.22.12a.46.46,0,0,0,.22.38c.12.07.22,0,.22-.12A.49.49,0,0,0,2.12,8.42Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.71,8.87c-.08,0-.14,0-.14.08a.3.3,0,0,0,.14.23l1.81,1c.07,0,.13,0,.13-.07a.29.29,0,0,0-.13-.23Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.12,2.14c-.13-.07-.22,0-.22.12a.46.46,0,0,0,.22.38c.12.07.22,0,.22-.12A.49.49,0,0,0,2.12,2.14Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.71,2.59c-.08,0-.14,0-.14.08a.3.3,0,0,0,.14.23L5,4.24c.08,0,.14,0,.14-.07A.29.29,0,0,0,5,3.94Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2.12,9.44c-.13-.07-.22,0-.22.12a.46.46,0,0,0,.22.38c.12.07.22,0,.22-.12A.49.49,0,0,0,2.12,9.44Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2.71,9.89c-.08,0-.14,0-.14.08a.3.3,0,0,0,.14.23l2.91,1.68c.07,0,.13,0,.13-.07a.29.29,0,0,0-.13-.23Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2,.93c-.12-.08-.22,0-.22.12A.46.46,0,0,0,2,1.43c.12.07.22,0,.22-.12A.49.49,0,0,0,2,.93Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2.6,1.38c-.08,0-.13,0-.13.08a.24.24,0,0,0,.13.22l2,1.16c.07,0,.13,0,.13-.07a.26.26,0,0,0-.13-.23Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.12,10.61c-.13-.07-.22,0-.22.12a.46.46,0,0,0,.22.38c.12.07.22,0,.22-.12A.49.49,0,0,0,2.12,10.61Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2.71,11.06c-.08,0-.14,0-.14.08a.3.3,0,0,0,.14.23l2,1.19c.07,0,.13,0,.13-.08a.3.3,0,0,0-.13-.23Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M15.58,7.21c.71-.87,1.65-1.19,3.26-.88A3.22,3.22,0,0,1,21.64,9c.35,1.21.14,5.47-3.14,5.46s-5.31-1.54-5.33-3.14,1.17-1.16,1.64-2.09C15.4,8.05,15.22,7.65,15.58,7.21Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M20.2,6.82a.54.54,0,0,0-.22.66c.17.68.46,2.4-.37,2.94-1.25.83-1.52,1.72-1.17,2.59a1.81,1.81,0,0,0,1.33,1.18c2.06-.93,2.17-4.17,1.87-5.2A3.42,3.42,0,0,0,20.2,6.82Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M12.71,14.06a8.66,8.66,0,0,0-.89.28c-.19.1-.05.3.11.34s.75,0,1,0a.16.16,0,0,0,.15-.09l.13-.24Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.55,10.36a18.41,18.41,0,0,0-2.23,1.34c-.44.54-2.17,2.74-2.17,2.74s-.62,0-.44-.38c0,0,1.27-2.73,1.52-3.11a16,16,0,0,1,2.14-1.9Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M15.33,15.18a8.52,8.52,0,0,0-.81.46c-.17.14,0,.3.18.31s.72-.19,1-.24a.16.16,0,0,0,.13-.11l.08-.26Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.11,9.53a19.77,19.77,0,0,0-1.6,2.37,24.39,24.39,0,0,0-.18,3.28c-.1.38.51.28.51.28a24.53,24.53,0,0,1,.89-3,11.25,11.25,0,0,1,1.4-1.36,1.66,1.66,0,0,0,.43-1.18Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M20.75,5.16l.4.11h0a1.51,1.51,0,0,0,.16-.41.27.27,0,0,0-.13-.34c-.05,0-.14,0-.27.18a.34.34,0,0,0-.05.12s-.05-.16-.12-.15S20.67,5,20.75,5.16Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M16.16,3.94,15.75,4h0a1.72,1.72,0,0,1-.12-.42.28.28,0,0,1,.16-.33c.05,0,.14,0,.25.2a.34.34,0,0,1,.05.12s.06-.15.13-.14S16.26,3.78,16.16,3.94Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M17.56,5.27a.63.63,0,0,1,.65-.7c.76,0,.92.66.77,1.17s0,.76.53.71a.46.46,0,0,1,.48.29h0a.45.45,0,0,1-.23.56c-.42.21-1.12.43-1.44-.07a2.91,2.91,0,0,1-.42-1.6S17.63,5.7,17.56,5.27Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M19.05,8a5.56,5.56,0,0,0-.42,2,.29.29,0,0,1-.33.29,2.47,2.47,0,0,1-2.07-1,.21.21,0,0,1,0-.25,1.53,1.53,0,0,0,.35-1.2c0-.33-.09-.72.36-.91l.08.78L15.78,5.87a.6.6,0,0,1-.12-.41L15.73,4l.45-.05.18,1.43.93.84L19,6.8,20,6.49l.74-1.36.43.11-.4,1.46a.76.76,0,0,1-.34.43Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M18,6.85h0a.31.31,0,0,0,.35-.29l.05-.5s-.29-.06-.28-.24.31-.19.31-.19l-.64-.06-.09.94A.32.32,0,0,0,18,6.85Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M18.4,5.86a.32.32,0,0,0,0,.22.21.21,0,0,1-.17.08l-.43,0A.23.23,0,0,1,17.57,6v-.7c.1.14.53.19.7.16a.52.52,0,0,0,.28-.17h0c.06,0,.17,0,.15.1a.46.46,0,0,1-.16.28A.32.32,0,0,0,18.4,5.86Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M18.1,5.63A1.54,1.54,0,0,0,19,5.3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M17.69,5.35a.84.84,0,0,1,.86-.73"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.19,5.55v.11a.12.12,0,0,1-.07.1l-.11,0-.55-.59.11,0a.2.2,0,0,1,0,.05,1,1,0,0,0,.46.28.26.26,0,0,0,.12,0S18.19,5.53,18.19,5.55Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M18,5.59s0,0,0,0l0,.19a.08.08,0,0,1,0,.06L17.72,6s0,0,0,0l0-.19a.08.08,0,0,1,0-.06Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M17.18,5.31a.08.08,0,0,0,0,.06l0,.19s0,0,0,0l.56.38s0,0,0,0l0-.19a.08.08,0,0,1,0-.06l-.56-.39Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M17.45,5.2h0l-.24.11.56.39h0L18,5.59h0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.55,5.14a.36.36,0,0,1,.13.29c0,.12-.06.18-.14.14a.4.4,0,0,1-.13-.29C11.41,5.16,11.47,5.1,11.55,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M12.56,6.44a.6.6,0,0,0,.08.16.69.69,0,0,0,.18.16.67.67,0,0,0,.25.08h0a.07.07,0,0,1,0,.06s0,0,0,0a.83.83,0,0,1-.29-.1.66.66,0,0,1-.23-.21.42.42,0,0,1-.1-.17.17.17,0,0,1-.1.06.3.3,0,0,1-.23,0,1.72,1.72,0,0,1-.29-.24.08.08,0,0,1,0-.08s0,0,0,0l0,0a1.28,1.28,0,0,0,.25.2.28.28,0,0,0,.18,0,.14.14,0,0,0,.08-.07l.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.49,5.94a.56.56,0,0,1,.29.4c0,.11-.1.15-.22.1l-.07,0-.07,0A.53.53,0,0,1,12.2,6C12.2,5.88,12.33,5.85,12.49,5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.44,6.22a.36.36,0,0,1,.13.29c0,.12-.06.18-.13.14a.36.36,0,0,1-.14-.29C13.3,6.24,13.36,6.18,13.44,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M13.79,5.89a2.72,2.72,0,0,1,.51,1.47c0,.83-.59,1.16-1.31.74l-1-.57a2.84,2.84,0,0,1-1.3-2.23c0-.48.2-.8.52-.89a.66.66,0,0,1,.21,0,1.18,1.18,0,0,1,.58.18l.08,0,.21.12.43.25.21.12.08,0a2.4,2.4,0,0,1,.58.49ZM13.11,7s0,0,0,0a.07.07,0,0,0,0-.06h0a.67.67,0,0,1-.25-.08.69.69,0,0,1-.18-.16.6.6,0,0,1-.08-.16c.12,0,.22,0,.22-.1a.56.56,0,0,0-.29-.4c-.16-.09-.29-.06-.29.07a.53.53,0,0,0,.22.35.14.14,0,0,1-.08.07.28.28,0,0,1-.18,0,1.28,1.28,0,0,1-.25-.2l0,0s0,0,0,0a.08.08,0,0,0,0,.08,1.72,1.72,0,0,0,.29.24.3.3,0,0,0,.23,0,.17.17,0,0,0,.1-.06.42.42,0,0,0,.1.17.66.66,0,0,0,.23.21.83.83,0,0,0,.29.1m.33-.31c.07,0,.13,0,.13-.14a.36.36,0,0,0-.13-.29c-.08,0-.14,0-.14.14a.36.36,0,0,0,.14.29m-1.9-1.08c.08,0,.14,0,.14-.14a.36.36,0,0,0-.13-.29c-.08,0-.14,0-.14.14a.4.4,0,0,0,.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M13.26,3.33a.7.7,0,0,1,.32.56V5.62A2.4,2.4,0,0,0,13,5.13l-.08,0V3.51C12.93,3.31,13.07,3.22,13.26,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M13.26,2.85a1.16,1.16,0,0,1,.54.92V5.89l-.21-.27V3.89a.7.7,0,0,0-.32-.56c-.19-.11-.33,0-.33.18V5.09L12.71,5V3.15C12.71,2.81,13,2.67,13.26,2.85Z"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M11.75,2.46a.73.73,0,0,1,.32.56V4.6l-.08,0a1.18,1.18,0,0,0-.58-.18V2.65C11.42,2.44,11.56,2.36,11.75,2.46Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M11.75,2a1.18,1.18,0,0,1,.54.93V4.72l-.21-.12V3a.73.73,0,0,0-.32-.56c-.19-.1-.33,0-.33.19V4.38a.66.66,0,0,0-.21,0V2.29C11.2,2,11.45,1.81,11.75,2Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M14.58,4.87a.34.34,0,0,1,.16.27c0,.1-.07.14-.16.09A.34.34,0,0,1,14.42,5C14.42,4.86,14.49,4.82,14.58,4.87Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M9.8,5.73a.14.14,0,0,1,.08.13.05.05,0,0,1-.08,0,.2.2,0,0,1-.08-.14A0,0,0,0,1,9.8,5.73Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M14.86,6.61a.17.17,0,0,1,.08.14s0,.07-.08,0a.16.16,0,0,1-.07-.13S14.82,6.59,14.86,6.61Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M10.56,1.68a.17.17,0,0,1,.08.13.05.05,0,0,1-.08.05.2.2,0,0,1-.08-.14A0,0,0,0,1,10.56,1.68Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M11.84,8.56a.31.31,0,0,1,.16.26c0,.1-.07.14-.16.09a.36.36,0,0,1-.15-.27C11.69,8.55,11.76,8.51,11.84,8.56Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M12.55,1.28a.34.34,0,0,1,.16.27c0,.09-.07.13-.16.08a.31.31,0,0,1-.16-.26C12.39,1.27,12.46,1.23,12.55,1.28Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M10.29,3.53a1.5,1.5,0,0,0,.46.78.35.35,0,0,0-.46.25,1.56,1.56,0,0,0-.46-.78A.35.35,0,0,0,10.29,3.53Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M13.44,8.69a.84.84,0,0,0,.27.46.21.21,0,0,0-.27.15.94.94,0,0,0-.27-.46A.2.2,0,0,0,13.44,8.69Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M14.25,2.46a.86.86,0,0,0,.27.47.2.2,0,0,0-.27.15A.9.9,0,0,0,14,2.62.21.21,0,0,0,14.25,2.46Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M10.56,7.22a.84.84,0,0,0,.27.46.21.21,0,0,0-.27.16,1,1,0,0,0-.27-.47A.2.2,0,0,0,10.56,7.22Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M18.84,2.66a.7.7,0,0,1,.22.23c.12.21.12.43,0,.5l-.45.25h-.05a.12.12,0,0,1,0-.05l-.39-.67-.06-.1c-.12-.2-.12-.43,0-.5a.23.23,0,0,1,.22,0,.58.58,0,0,1,.22.22l.06.11.06,0A.25.25,0,0,1,18.84,2.66Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse701);
export default __webpack_public_path__ + "static/media/metaverse7-01.6f11e476b169e205c5f5e9cce29bb90e.svg";
export { ForwardRef as ReactComponent };